import { OptionsType } from '@openx/types/options.ts';
import { useOptionsFetch } from '@openx/utils/apiHooks/generics/useOptionsFetch.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { prepareCategoryOptions } from '../../Targeting/Category/utils.ts';

export function useCategoriesFetch() {
  const { t } = useTranslation();
  const {
    isLoading: isCategoriesLoading,
    data: categories,
    refetch: refetchCategories,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Categories'),
    optionType: OptionsType.AD_CATEGORIES,
    queryOptions: { enabled: false },
  });

  const preperedCategories = useMemo(
    () => (categories ? prepareCategoryOptions(categories, t('(All)')) : {}),
    [categories, t]
  );

  return {
    categories: preperedCategories,
    isCategoriesLoading,
    rawCategories: categories,
    refetchCategories,
  };
}
